var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShieldEmpty = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 84,
    viewBox: "0 0 61 84",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D00000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.032 45.862c0 10.685-5.989 18.558-23.49 30.46C13.04 64.42 7.05 56.547 7.05 45.861V18.775c8.704-.925 15.67-3.887 23.49-9.934 7.82 6.047 14.788 9.009 23.491 9.933v27.088zm5.138-33.525c-10.294-.233-17.372-2.711-27.343-11.2C31.47.834 31.004.68 30.541.68c-.465 0-.928.153-1.286.457-9.968 8.489-17.046 10.967-27.341 11.2C.968 12.358.2 13.112.2 14.043v31.82C.2 61.33 10.707 71.34 29.117 83.528c.392.26.909.39 1.424.39.517 0 1.032-.13 1.424-.39 18.41-12.188 28.918-22.198 28.918-37.667V14.043c0-.931-.767-1.685-1.713-1.706z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShieldEmpty, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shield_empty.c0b91035.svg";
export { ForwardRef as ReactComponent };